import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { Alert as SharedAlertComponent } from "../../sharedComponents/Alert";
import { RCL as useTranslation } from "../RCL";
import { HeadingType as AlertTitleType } from "../Headings/Heading";
import { Icon } from "../Icons";
import * as styles from "./AlertComponent.module.scss";

const defaultClassNames = {
	heading: styles.alertComponentHeading,
	body: styles.alertComponentBody,
	dismissibleButton: styles.alertComponentClose,
};

const AlertComponent = ({
	className,
	classNames: providedClassNames,
	children,
	heading,
	headingAs,
	variant,
	dismissible,
	labels: providedLabels,
	icon,
	iconName,
}) => {
	const classNames = { ...defaultClassNames, ...providedClassNames };

	const defaultLabels = {
		closeAlert: useTranslation({ searchKey: "close-alert" }),
	};

	const labels = {
		...defaultLabels,
		...providedLabels,
	};

	const classes = cx(styles.alertComponent, {
		[styles[variant]]: variant && styles[variant],
		[className]: className,
	});

	let iconType = "";

	switch (variant) {
		case "error":
			iconType = "close";
			break;
		case "info":
			iconType = "info";
			break;
		case "success":
			iconType = "checked";
			break;
		case "none":
			// eslint-disable-next-line no-param-reassign
			icon = null;
			break;
		default:
			iconType = "alert";
	}

	return (
		<SharedAlertComponent
			className={classes}
			classNames={classNames}
			heading={heading}
			headingAs={headingAs}
			variant={variant}
			labels={labels.closeAlert}
			dismissible={dismissible}
			dismissibleIcon={<Icon name="close--n" />}
			icon={
				(iconName || icon) && <Icon className={styles.alertIcon} name={iconName ?? iconType} />
			}>
			{children}
		</SharedAlertComponent>
	);
};

AlertComponent.propTypes = {
	className: PropTypes.string,
	classNames: PropTypes.shape({
		heading: PropTypes.string,
		body: PropTypes.string,
		dismissibleButton: PropTypes.string,
	}),
	children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
	heading: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
	headingAs: PropTypes.oneOf(Object.keys(AlertTitleType)),
	variant: PropTypes.oneOf(["success", "danger", "warning", "info", "none"]),
	labels: PropTypes.shape({
		closeAlert: PropTypes.string,
	}),
	dismissible: PropTypes.bool,
	icon: PropTypes.oneOfType([PropTypes.node, PropTypes.element]),
	iconName: PropTypes.string,
};

AlertComponent.defaultProps = {
	className: undefined,
	classNames: {},
	children: undefined,
	heading: undefined,
	headingAs: AlertTitleType.h2,
	variant: "danger",
	labels: undefined,
	dismissible: true,
	icon: undefined,
	iconName: undefined,
};

export default AlertComponent;
export { AlertComponent };
